export const cards = {
  creature: {
    red: [
      {
        name: 'Goblin',
        level: 1,
        set_emblem: '♂',
        effect: 'Haste (This creature can attack the turn it is summoned.)',
        damage: 1,
        health: 1,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Acid Bearer',
        level: 2,
        set_emblem: '♂',
        effect:
          'This creature can be sacrficed at any time to deal 2 damage to a target.',
        damage: 2,
        health: 1,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Unstable Demon',
        level: 3,
        set_emblem: '♂',
        effect: 'Haste; This creature dies at the end of the turn it attacks.',
        damage: 8,
        health: 1,
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    green: [
      {
        name: 'Elf',
        level: 1,
        set_emblem: '♂',
        effect:
          'Trample (When this creature deals more damage than a creature has health, the remaining damage goes through.)',
        damage: 2,
        health: 2,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Wolf Pack',
        level: 2,
        set_emblem: '♂',
        effect:
          'To block this creature it must be blocked by 2 or more creatures.',
        damage: 2,
        health: 3,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Ent',
        level: 3,
        set_emblem: '♂',
        effect: 'This creature is a tree.',
        damage: 5,
        health: 5,
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    blue: [
      {
        name: 'Slime',
        level: 1,
        set_emblem: '♂',
        effect:
          'Regenerate (When this creature dies, you may pay its cost to heal it once per turn)',
        damage: 1,
        health: 1,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Siren',
        level: 2,
        set_emblem: '♂',
        effect:
          "When this creature deals damage to a player, It's owner gains life equal to the damage dealt.",
        damage: 2,
        health: 3,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Glacier Wall',
        level: 3,
        set_emblem: '♂',
        effect: 'Wall',
        damage: 0,
        health: 7,
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    orange: [
      {
        name: 'Barricade',
        level: 1,
        set_emblem: '♂',
        effect:
          "Wall (This creature can't attack. Can block any number of attackers with total damage up to the wall's health.)",
        damage: 0,
        health: 3,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Knight',
        level: 2,
        set_emblem: '♂',
        effect: 'When this creature blocks it deals damage with its health',
        damage: 1,
        health: 4,
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Stone Golem',
        level: 3,
        set_emblem: '♂',
        effect: 'When this creature attacks its damage and health are swapped.',
        damage: 2,
        health: 6,
        creator: 'Bradley McKane',
        year: 2020
      }
    ]
  },
  spell: {
    red: [
      {
        name: 'Fire Bolt',
        level: 1,
        set_emblem: '♂',
        effect: 'Deal 2 damage to a single target.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Ambush',
        level: 2,
        set_emblem: '♂',
        effect: 'Up to 3 of your creatures deal damage first in combat',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Chain Lightning',
        level: 3,
        set_emblem: '♂',
        effect: 'Deal 3 damage to up to 3 target creatures.',
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    green: [
      {
        name: 'Fury',
        level: 1,
        set_emblem: '♂',
        effect: 'Give a single creature +2 damage until the end of the turn.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Cheap Shot',
        level: 2,
        set_emblem: '♂',
        effect:
          'Target creature you control deals its damage to a creature your opponent controls',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Leap',
        level: 3,
        set_emblem: '♂',
        effect:
          'Target creature can only be blocked by creatures with flying this turn.',
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    blue: [
      {
        name: 'First Aid',
        level: 1,
        set_emblem: '♂',
        effect: 'Restore 2 health to a single target.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Confuse',
        level: 2,
        set_emblem: '♂',
        effect: 'Target one attacking creature. Its attack is cancelled.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Vanish',
        level: 3,
        set_emblem: '♂',
        effect:
          'Target creature cant attack, block, or be targeted by spells or effects until the end of the turn',
        creator: 'Bradley McKane',
        year: 2020
      }
    ],
    orange: [
      {
        name: 'Fortify',
        level: 1,
        set_emblem: '♂',
        effect: 'Give a single creature +2 Health until the end of the turn.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Crush',
        level: 2,
        set_emblem: '♂',
        effect: 'Deal 4 damage to a single creature.',
        creator: 'Bradley McKane',
        year: 2020
      },
      {
        name: 'Sandstorm',
        level: 3,
        set_emblem: '♂',
        effect: 'All creature effects are disabled in combat this turn.',
        creator: 'Bradley McKane',
        year: 2020
      }
    ]
  }
};
